import React from 'react';
import { processText } from '@/shared/libs/process-text';
import { useLocaleFormat } from '@/shared/hooks';

import {
  HeadingBoldH5,
  BodyTextRegularB,
} from '@/shared/ui/typography2';

import { GamesWrapper, ProviderImage } from '../styles';
import { Box } from '@/shared/ui/box';

import { Condition } from '@/shared/ui/condition';

import { ConditionalWrapperGame } from '@/entities/game/ui/сonditional-wrapper-game';

export const BonusGamesAndProviders = ({
  bonus,
  providers,
  games,
  tCommon,
  t,
  router,
  locale,
}) => {
  const formatUrl = useLocaleFormat();

  const currentProvider = providers?.find(
    (provider) => bonus?.provider === provider.id
  );

  return (
    <>
      <Condition match={!Boolean(currentProvider) && !Boolean(bonus?.games)}>
        <BodyTextRegularB> {t('card.allowed_all')}</BodyTextRegularB>

      </Condition>

      <Condition match={!!currentProvider}>
        <HeadingBoldH5> {tCommon('filter.label.provider')}</HeadingBoldH5>
        <Box
          $padding="16px"
          $borderRadius="8px"
          $textAlign="center"
          $width="max-content"
          $background="#27262B"
          $margin="0 auto"
          onClick={() => router.push(`/${locale}/games/${currentProvider?.id}`)}
        >
          <ProviderImage
            style={{ objectFit: 'contain' }}
            src={currentProvider?.imageUrl}
            width={66}
            height={40}
            alt={currentProvider?.name}
          />
        </Box>
      </Condition>

      <Condition match={bonus?.games}>
        <HeadingBoldH5>
          {bonus?.games?.length === 1
            ? t('card.modal_game')
            : t('card.modal_games')}
        </HeadingBoldH5>

        <GamesWrapper $centered={bonus?.games?.length === 1}>
          {games
            .filter((game) => bonus?.games?.includes(game.id))
            .map((game) => {
              return (
                <ConditionalWrapperGame
                  key={game.id}
                  game={game}
                  handleClickGame={() =>
                    router.push(formatUrl( `/games/${processText(game?.providerId)}/${game?.code||processText(game?.title)}/play`))
                  }
                  hasScroll={false}
                />
              );
            })}
        </GamesWrapper>
      </Condition>
    </>
  );
};
